import React, { useEffect, useRef, useState } from 'react';
import Dropzone from 'dropzone';
import 'dropzone/dist/dropzone.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import '../styles/formularios.css';
import '../styles/styles.css';
import logoInstituto from '../components/images/logo.png';
import logoSEP from '../components/images/SEP_Logo_2019.svg.png';

Dropzone.autoDiscover = false;

const ModificarEvidencias = () => {
  const dropzoneRef = useRef(null);

  const [formVisible, setFormVisible] = useState(false);
  const [selectedId, setSelectedId] = useState('');
  const [descripcion, setDescripcion] = useState('');
  const [tema, setTema] = useState('');
  const [idEvidencia, setIdEvidencia] = useState('');

  const evidencias = {
    1: { id: 1, descripcion: 'Evidencia de Matemáticas', tema: '1' },
    2: { id: 2, descripcion: 'Evidencia de Español', tema: '2' },
    3: { id: 3, descripcion: 'Evidencia de Ciencias', tema: '3' },
  };

  useEffect(() => {
    if (dropzoneRef.current && Dropzone.instances.length === 0) {
      const dz = new Dropzone(dropzoneRef.current, {
        url: '/fake-upload',
        autoProcessQueue: false,
        addRemoveLinks: true,
        acceptedFiles: '.jpg,.png,.jpeg,.pdf,.docx,.xlsx,.pptx',
        maxFilesize: 5,
        dictDefaultMessage: 'Arrastra y suelta tus archivos aquí o haz clic para seleccionarlos.',
      });

      return () => dz.destroy();
    }
  }, []);

  const handleSeleccionEvidencia = (e) => {
    const value = e.target.value;
    const evidencia = evidencias[value];
    if (evidencia) {
      setFormVisible(true);
      setSelectedId(value);
      setIdEvidencia(evidencia.id);
      setDescripcion(evidencia.descripcion);
      setTema(evidencia.tema);
    }
  };

  return (
    <div className="container py-4 px-4">
      {/* Encabezado */}
      <div className="d-flex justify-content-between align-items-center mb-4">
        <img src={logoInstituto} alt="Logo Instituto" className="logo" />
        <div className="flex-grow-1 text-center">
          <h4 className="mb-0">Instituto Silviano Carrillo</h4>
          <small className="text-muted fs-5">Modificar Evidencias</small>
        </div>
        <img src={logoSEP} alt="Logo SEP" className="logo" />
      </div>

      {/* Selector de evidencia */}
      <div className="mb-4">
        <label htmlFor="selectorEvidencia" className="form-label">Selecciona una evidencia para modificar:</label>
        <select
          id="selectorEvidencia"
          className="form-select"
          onChange={handleSeleccionEvidencia}
          value={selectedId}
        >
          <option value="" disabled>Seleccionar evidencia</option>
          <option value="1">#1 - Evidencia de Matemáticas</option>
          <option value="2">#2 - Evidencia de Español</option>
          <option value="3">#3 - Evidencia de Ciencias</option>
        </select>
      </div>

      {/* Formulario */}
      {formVisible && (
        <div className="p-4 bg-light rounded shadow-sm" id="formularioContainer">
          <form className="row g-3" id="formularioEvidencias">
            <div className="col-md-4">
              <label htmlFor="idEvidencia" className="form-label">ID Evidencias</label>
              <input
                type="text"
                className="form-control"
                id="idEvidencia"
                value={idEvidencia}
                readOnly
              />
            </div>

            <div className="col-md-8">
              <label htmlFor="descripcion" className="form-label">Descripción</label>
              <input
                type="text"
                className="form-control"
                id="descripcion"
                value={descripcion}
                onChange={(e) => setDescripcion(e.target.value)}
              />
            </div>

            <div className="col-md-6">
              <label htmlFor="temaPlaneacion" className="form-label">Tema de Planeación</label>
              <select
                id="temaPlaneacion"
                className="form-select"
                value={tema}
                onChange={(e) => setTema(e.target.value)}
              >
                <option value="" disabled>Seleccionar</option>
                <option value="1">Matemáticas - Tema 1</option>
                <option value="2">Español - Tema 2</option>
                <option value="3">Ciencias - Tema 3</option>
              </select>
            </div>

            <div className="col-12">
              <label className="form-label">Subir Evidencias (imágenes, archivos, links)</label>
              <div id="dropzoneDemo" className="dropzone" ref={dropzoneRef}></div>
            </div>
          </form>
        </div>
      )}

      {/* Botones */}
      <div className="d-flex justify-content-center gap-3 mt-4">
        <button className="btn btn-primary px-4">Guardar Cambios</button>
        <button className="btn btn-danger px-4">Salir</button>
      </div>
    </div>
  );
};

export default ModificarEvidencias;
